//export const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://signapi.kycaml.systems/"

/*
  https://esign.kycaml.systems/?company-id=13&&user-id=10264
*/
//export const NEST_BACKEND_URL = process.env.REACT_APP_NEST_BACKEND_URL || "https://sign.kycaml.systems/";
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://stagingsignapi.kycaml.systems/"

/*
  https://esign.kycaml.systems/?company-id=13&&user-id=10264
*/
export const NEST_BACKEND_URL = process.env.REACT_APP_NEST_BACKEND_URL || "https://stagingsign.kycaml.systems/";

